import {IsEmail, IsNotEmpty, NotEquals} from "class-validator";
import {MeetsPasswordCriteria} from "../../validators/meetsPasswordCriteria.validator";
import {PasswordReset} from "./passwordReset.model";

class PasswordResetForm {
    @IsEmail({blacklisted_chars: "+"}, { message : "Please enter a valid email"})
    @IsNotEmpty({ message: "Please enter a valid email" })
    userName: string;
}

export { PasswordResetForm }